// context/PartnerProvider.js
import { createContext, useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { apiInstance, setDynamicToken } from "./axios";

const PartnerContext = createContext();

export const PartnerProvider = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const match = location.pathname.match(/^\/([^/]+)/);
    const UserCode = match ? match[1] : null;
    const [partnerData, setPartnerData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const didFetchRef = useRef(false);
    useEffect(() => {
        const fetchPartnerData = async () => {
            if (didFetchRef.current || !UserCode) return;
            didFetchRef.current = true;

            // Set token for axios globally
            setDynamicToken(UserCode);

            try {
                const response = await apiInstance.post("/Partner/GetPartnerDataByLinkCode");

                if (response.data?.Data?.Status === true) {
                    setPartnerData(response.data.Data);
                } else {
                    navigate("/not-found");
                }
            } catch (error) {
                console.error("Error fetching partner data:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchPartnerData();
    }, [UserCode, navigate]);

    return (
        <PartnerContext.Provider value={{ partnerData, isLoading, UserCode }}>
            {children}
        </PartnerContext.Provider>
    );
};

export const usePartner = () => useContext(PartnerContext);
